import React from "react";
import { graphql } from "gatsby"
import { Helmet } from "react-helmet";
import Img from "gatsby-image"
import Markdown from "../../components/Markdown"

import style from "./index.module.css";
import page from "../../config/global-styles/content.module.css";

export default ({ data }) => {
  const article = data.articleContent
  return (
    <div>
      <Helmet>
        <title>Update - {article.title}</title>
      </Helmet>
      <article>
        <div className={style.imageContainer}>
          <Img className={style.image} fluid={article.image.fluid} />
        </div>

        <div className={page.content}>
          <div className={page.text}>
            <h1>{article.title}</h1>
            {article.body.body &&
              <Markdown source={article.body.body} softBreak="br" className="text" />
            }
          </div>
        </div>
      </article>
    </div>
  )
}

export const query = graphql`
  query articleQuery($slug: String) {
    articleContent: contentfulNieuwsartikelUpdate(slug: { eq: $slug }) {
      slug
      id
      title
      category
      date
      description {description}
      image {
        fluid(maxWidth: 2500) {
          aspectRatio
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
        }
      }
      body {body}
    }
  }
`